import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/** 경영 분석 탭 공통 정산월 목록 — 굳힌 달 + 최신 명세 달(최신순). */
export function useProfitMonths(onError: (m: string) => void): [string[], string, (m: string) => void] {
  const [months, setMonths] = useState<string[]>([]);
  const [mon, setMon] = useState('');
  useEffect(() => {
    api.listProfitTrend({}).then((r) => {
      const set = new Set(r.rows.map((x) => x.mon));
      if (r.latestSalaryMon) set.add(r.latestSalaryMon);
      const ms = [...set].sort().reverse();
      setMonths(ms); setMon((m) => m || ms[0] || '');
    }).catch((e) => onError(e instanceof Error ? e.message : String(e)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return [months, mon, setMon];
}

